import { RootState } from '../RootState';
import { initialPanelComerciales } from './panel_comerciales.initial';

const slice = (state: RootState) => state.panel_comerciales ?? initialPanelComerciales;

export const selectPanelComerciales = (state: RootState) => slice(state);
export const selectPanelMeta = (state: RootState) => slice(state).snapshot.meta;
export const selectFlowTypes = (state: RootState) => slice(state).snapshot.meta.flowTypes;
export const selectTeams = (state: RootState) => slice(state).snapshot.teams;
export const selectCommercials = (state: RootState) => slice(state).snapshot.commercials;
export const selectVips = (state: RootState) => slice(state).snapshot.vips;
export const selectNotifications = (state: RootState) => slice(state).snapshot.notifications;
export const selectAuditLog = (state: RootState) => slice(state).snapshot.auditLog;
export const selectPanelLoading = (state: RootState) => slice(state).loading;
export const selectPanelSaving = (state: RootState) => slice(state).saving;
export const selectPanelError = (state: RootState) => slice(state).error;
export const selectActiveTeamNames = (state: RootState) =>
    slice(state).snapshot.teams.filter((t) => t.active).map((t) => t.name);
